import { Reveal, Kicker } from "./motion";

const KITS = [
  ["01-kit-cartoes-educativos", "Cartões Educativos"],
  ["02-kit-7-projetos-educativos", "7 Projetos Educativos"],
  ["03-kit-jogos-educativos", "Jogos Educativos"],
  ["04-kit-alfabetizacao-infantil", "Alfabetização Infantil"],
  ["05-kit-matematica-infantil", "Matemática Infantil"],
  ["06-kit-educacao-especial", "Educação Especial"],
  ["07-kit-datas-comemorativas", "Datas Comemorativas"],
  ["08-kit-planos-de-aula", "Planos de Aula"],
];
const AUDIENCE = ["Famílias", "Escolas", "Creches", "Professores", "Reforço escolar", "Terapeutas", "Papelarias"];

const Card = ({ k, idx, hidden }) => (
  <figure
    className={`kit-card group relative mx-3 w-[200px] shrink-0 sm:mx-4 sm:w-[260px] ${idx % 2 ? "mt-10" : ""}`}
    data-testid={hidden ? undefined : `kit-card-${idx}`}
    aria-hidden={hidden || undefined}
  >
    <div className="relative aspect-[453/680] overflow-hidden rounded-[28px] bg-white shadow-[0_30px_60px_-30px_rgba(26,16,48,0.6)] ring-1 ring-ink/5">
      <img src={`/img/kits/${k[0]}.webp`} alt={hidden ? "" : `Kit de ${k[1]}`} loading="lazy" width={453} height={680}
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]" />
    </div>
    <figcaption className="mt-3 flex items-center gap-2 font-display text-sm font-bold text-ink">
      <span className="h-1.5 w-1.5 rounded-full bg-rose" /> Kit {k[1]}
    </figcaption>
  </figure>
);

export const KitMarquee = () => (
  <section className="overflow-hidden bg-lilac py-20 sm:py-28" data-testid="kits-section">
    <div className="mx-auto max-w-6xl px-5">
      <Reveal>
        <Kicker>O que você vai vender</Kicker>
        <p className="mt-5 max-w-3xl font-display text-3xl font-extrabold leading-[1.05] tracking-tight text-ink sm:text-5xl">
          Atividades bonitas, prontas para imprimir. <span className="text-plum">E com muita gente procurando:</span>
        </p>
        <div className="mt-7 flex flex-wrap gap-2">
          {AUDIENCE.map((a, i) => (
            <span key={a} data-testid={`audience-chip-${i}`}
              className="rounded-full border border-ink/10 bg-white px-4 py-2 text-sm font-semibold text-ink transition-colors duration-300 hover:bg-ink hover:text-white">
              {a}
            </span>
          ))}
        </div>
      </Reveal>
    </div>
    <div className="marquee mt-14 flex w-max" data-testid="kits-marquee">
      {[0, 1].map((g) => (
        <div key={g} className="marquee-group flex items-start">
          {KITS.map((k, i) => <Card key={k[0]} k={k} idx={i} hidden={g === 1} />)}
        </div>
      ))}
    </div>
  </section>
);
